// extracted by mini-css-extract-plugin
module.exports = {"main-component":"logout_main-component__Im1gO"};